import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import { CountData, ListData, SupplierOrderData } from './types'

export const selectSupplierOrderListEvent = (state: RootState): Event => state.supplierOrderReducer.listEvent

export const selectSupplierOrderList = (state: RootState): ListData => state.supplierOrderReducer.list

export const selectSupplierOrderActionEvent = (state: RootState): Event =>
  state.supplierOrderReducer.actionEvent

export const selectSupplierOrderDetail = (state: RootState): SupplierOrderData | undefined =>
  state.supplierOrderReducer.detail

export const selectSupplierOrderDetailEvent = (state: RootState): Event =>
  state.supplierOrderReducer.detailEvent

export const selectSupplierOrderCountData = (state: RootState): CountData | undefined =>
  state.supplierOrderReducer.countData
